$(document).ready(function () {
  if ($("body.template-product").length != 0) {
    setTimeout(function () {
      console.log("helo wold");
      var api = new Yotpo.API(yotpo);
      api.refreshWidgets();
    }, 3000);
  }
  function loadreview() {
    setTimeout(function () {
      var api = new Yotpo.API(yotpo);
      api.refreshWidgets();
    }, 1000);
  }
  $(".t4s-tabs-collection ul.t4s-tabs-ul li").click(function () {
    console.log("htmllo");
    loadreview();
  });
});
